import { Helmet } from 'react-helmet';

export const BrowserTitle = ({ children }: { children?: string }) => (
  <Helmet>
    <title>{children ? `${children} | ` : ''}Banking | quirion.de</title>
  </Helmet>
);
